import styled, { css } from 'styled-components'
import { Button } from '@material-ui/core'
import { theme } from '@provi/provi-components'

const handleColors = (disabled) => {
  if (disabled) {
    return css`
      &.MuiButton-contained.Mui-disabled {
        background: #bdbdbd;
      }
      .MuiButton-label {
        color: #ffffff;
      }
    `
  }

  return css`
    background-color: #f56b00;
    .MuiButton-label {
      color: #ffffff;
    }
    .MuiTouchRipple-ripple {
      color: #f56b00;
    }
    :hover {
      background-color: #d35c00;
    }
    :focus {
      background-color: #d35c00;
    }
  `
}

const resizeButton = (footerButton) => {
  if (footerButton) {
    return css`
      ${theme.breakpoints?.down('sm')} {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        min-width: 100vw;
        .MuiButton-root {
          border-radius: 0;
        }
      }
    `
  }
}

export const ButtonContainer = styled.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: fit-content;
  height: 48px;
  border-radius: 4px;
  min-width: ${({ buttonWidth }) => buttonWidth};
  height: ${({ buttonHeight }) => buttonHeight};
  ${theme.breakpoints?.down('md')} {
    min-width: ${({ mobileWidth }) => mobileWidth};
  }
  .MuiButton-root {
    ${({ disabled }) => handleColors(disabled)}
  }
  .MuiButton-label {
    color: #d35c00;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.005em;
    text-transform: none;
  }
  :focus,
  :focus-within {
    outline: 2px auto #d35c00;
    outline-offset: 2px;
  }
  ${({ footerButton }) => resizeButton(footerButton)}
`

export const ButtonWrapper = styled(Button)`
  border-radius: 4px;
  width: 100%;
  height: 100%;
`
